import { Form } from 'react-bootstrap'
import ModalCustom from '../../UI/modal'
import Button from '../../UI/button'
import { IdType } from '../../types/card'

type Props = {
	show: boolean
	handleClose: () => void
	id?: IdType | null
}

const EditFolderModal = ({show, handleClose, id}: Props) => {
  return (
	<ModalCustom show={show} onHide={handleClose} title='Edit The Folder Info'>
		<Form>
			<Form.Group className='mb-3'>
				<Form.Label>Title</Form.Label>
				<Form.Control required type='text' placeholder='Enter here' />
			</Form.Group>
			<Button variant='primary' className='mx-auto' size='md' width={153}>Update</Button>
		</Form>
	</ModalCustom>
  )
}
export default EditFolderModal